import * as React from "react";
import { hashHistory } from "react-router";
import { Grid, Row, Col } from "react-flexbox-grid";
import IconButton from "material-ui/IconButton";
import ArrowButton from "material-ui-icons/ArrowBack";

export default class BackButton extends React.Component<{}, {}> {
  constructor(props: any) {
    super(props);
  }
  render(): JSX.Element {
    // This should be normalized and imported
    const styles = {
      MuiIconButton: {
        color: "#5B6770",
        margin: "16px 16px 0 16px",
      },
    };
    return <Row>
      <IconButton style={styles.MuiIconButton} aria-label="arrow-back" onClick={() => hashHistory.goBack()}><ArrowButton /></IconButton>
    </Row>; 
  }
}


// WEBPACK FOOTER //
// ./src/components/widgets/backBtn/index.tsx